module.exports = __webpack_public_path__ + "static/media/aster_fabrics.187bae02.png";